import React, { createContext, useCallback, useMemo, useState } from 'react';

export const RemoveLoggerContext = createContext(null);

export const RemoveLoggerContextWrapper = ({ children, maxStep = 2 }) => {
    const [curStep, setCurStep] = useState<number>(1);
    const [asset, setAsset] = useState({ number: null });
    const [logger, setLogger] = useState({ number: null });

    const nextStep = useCallback(() => {
        if (curStep >= maxStep) return;
        setCurStep(curStep + 1);
    }, [curStep, maxStep, setCurStep]);

    const prevStep = useCallback(() => {
        if (curStep <= 1) return;
        setCurStep(curStep - 1);
    }, [curStep, setCurStep]);

    const value = useMemo(() => ({
        stepper: { curStep, setCurStep, nextStep, prevStep, maxStep },
        asset,
        setAsset,
        logger,
        setLogger,
    }), [curStep, setCurStep, asset, setAsset, logger, setLogger]);

    return (
        <RemoveLoggerContext.Provider value={value}>
            {children}
        </RemoveLoggerContext.Provider>
    );
};
